import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-save-button',
  templateUrl: './save-button.component.html',
  styleUrl: './save-button.component.scss'
})
export class SaveButtonComponent {

  @Output() save: EventEmitter<void> = new EventEmitter<void>();

  onSave(){
    this.save.emit();
  }

}
